require("./ynet_site_redMailComponenta.less")

import * as classNames from "classnames"
import { RedMailFileUploadYnet } from "./filesUpload/RedMailFileUploadYnet";
import { RedMailComponentaProps } from "../interfaces/redMailInterfaces";
import { ExtraDetailsYnet } from "./extraDetails/extraDetailsYnet"
import { PopUpYnet } from "./popUp/popUpYnet"

export interface RedMailComponentaYnetProps extends RedMailComponentaProps {
    handleRemoveFile?: (fileKey: string) => void;
}

export class RedMailComponentaYnet extends React.Component<RedMailComponentaYnetProps & {isChecked: boolean}, {}>{

    private focusFirstInvalidField = () => {
        const { isTextAreaBlank, isAgreementApproved, countSubmitAttempts } = this.props;

        const focusElement = (element: HTMLElement) => {
            element.focus();
            element.scrollIntoView({ behavior: "smooth", block: "center" });
        }

        if (isTextAreaBlank) {
            const textArea = document.querySelector(".redMailFormContent .textAreaWrapper textarea") as HTMLTextAreaElement;
            if (textArea) {
                focusElement(textArea);
                return;
            }
        }

        const firstValidationError = document.querySelector(".redMailFormContent .redMail-error-validation") as HTMLElement;
        if (firstValidationError) {
            const inputField = firstValidationError.closest(".inputField");
            const invalidInput = inputField && inputField.querySelector("input") as HTMLInputElement;
            if (invalidInput) {
                focusElement(invalidInput);
                return;
            }
        }

        if (!isAgreementApproved && countSubmitAttempts > 0) {
            const agreementInput = document.getElementById("agreementApproved") as HTMLInputElement;
            if (agreementInput) {
                focusElement(agreementInput);
            }
        }
    }

    public componentDidUpdate(prevProps: RedMailComponentaYnetProps & { isChecked: boolean }) {
        if (this.props.countSubmitAttempts > prevProps.countSubmitAttempts) {
            setTimeout(this.focusFirstInvalidField, 0);
        }
    }

    public render() {
        const { handleChangeText, isTextAreaBlank, countSubmitAttempts, textArea,
                handleSelectedFile, selectedFiles, hashes, invalidFilesName, showFileStatusProgress,
                photographer, sender, mail, phoneNumber, validation, handleChangeExtraData, isAgreementApproved,
                IsPopUp, submitForm, loading, onClose, submitButtonDisabled, isChecked, handleRemoveFile } = this.props;

        const ynetTermsHref = "https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html";
        const ynetPolicyHref = "https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html";
        const ynetTermsLink = <a href={ynetTermsHref} className="termsClick">תנאי השימוש</a>
        const ynetPolicyLink = <a href={ynetPolicyHref} className="termsClick">מדיניות הפרטיות</a>
        const isApp = typeof window !== "undefined" && window.location.href.indexOf("IsApp") != -1;

        const extraDetailsData = {
            title: "פרטים נוספים (אופציונלי)",
            subTitle: "",
            mailPattern: "צריך להיות בתבנית הבאה: ynet@ynet.com"
        };

        const terms = <>הריני לאשר שהתוכן שאשלח: מקורי, לא מזויף או מבוים, לא מימנתי את הפקתו, הוא אינו מועתק או נגוע במעשה בלתי חוקי כגון הסגת גבול ופגיעה בפרטיות. התוכן לא הופק, לא נערך ולא עבר כל עיבוד באמצעות בינה מלאכותית (AI), בין באופן מלא ובין באופן חלקי. אני מצהיר כי אני מודע לכך שחל איסור לשלוח תוכן שאינו עומד בכללים אלה. כמו כן, התוכן לא נשלח לשום גורם אחר במקביל והוא מועבר לבעלותכם הבלעדית, ללא עלות וללא מגבלה. פרטיי מהימנים לטובת קרדיט לצד פרסום התוכן, אם תבחרו לפרסמו ובמידה ותידרשו למסור אותם לגורם רשמי. קראתי, הבנתי ומסכים לאמור ב{ynetTermsLink} וב{ynetPolicyLink} ולקבלת דיוורים מאתר ynet.</>

        return (
            <div>
               <div className={classNames("RedMailComponenta", { "isApp": isApp })}>
                 <div className="redMailLeftSide">
                    <div className="redMailHeadline">
                        <div className="headlineLogo">
                            <div className="headlineImage_circle">
                                <div className="headlineImage" />
                            </div>
                            <p className="headlineTitle">המייל האדום</p>
                        </div>
                        <p className="headlineSubtitle">
                            יש לכם מידע חשוב שטרם נחשף? צילומים מאירוע חדשותי? מצאתם טעות בכתבה?
                        </p>
                    </div>
                    
                     {IsPopUp ? 
                     <PopUpYnet onClose={onClose} loading={loading} />
                     :
                     <div className="redMailFormWrapper">
                        <div className="redMailFormContent">
                            <p className="formContentTitle">שתפו אותנו כאן</p>
                            <div className="textAreaWrapper">
                                <textarea
                                    dir="rtl"
                                    placeholder="*מה תרצו לשתף?"
                                    value={textArea}
                                    resize="vertical"
                                    onChange={(e) => handleChangeText(e)}
                                    className={classNames({
                                        "placeholderErrorStyle": isTextAreaBlank,
                                        "invalidInput": isTextAreaBlank && countSubmitAttempts > 0
                                    })}
                                />
                            </div>
                            {isTextAreaBlank && countSubmitAttempts > 0 && (
                                <div className="contentErrorMessage">נראה ששכחת לצרף את תוכן ההודעה</div>
                            )}

                            <RedMailFileUploadYnet
                                handleSelectedFile={handleSelectedFile}
                                selectedFiles={selectedFiles}
                                hashes={hashes}
                                invalidFilesName={invalidFilesName}
                                showFileStatusProgress={showFileStatusProgress}
                                handleRemoveFile={handleRemoveFile}
                            />
                             <div className="upload_text">
                                 ניתן להעלות קבצי mov, png, jpeg, jpg, mp4 עד 200MB 
                             </div>

                            <ExtraDetailsYnet
                                photographer={photographer}
                                sender={sender}
                                mail={mail}
                                phoneNumber={phoneNumber}
                                onChange={handleChangeExtraData}
                                validation={validation}
                                extraDetailsData={extraDetailsData}
                            />

                            <p className="terms">
                                <input className="checkBox" id="agreementApproved" type="checkbox" checked={isAgreementApproved} onChange={(e) => handleChangeExtraData(e)} />
                                <p className="termsText">{terms}</p>
                                {!isAgreementApproved && countSubmitAttempts > 0 && (
                                <div className="contentErrorMessage terms-error">יש לאשר את תנאי השימוש</div>
                                )}
                            </p>
                           

                            <button
                                disabled={submitButtonDisabled}
                                className="submitButton"
                                type="submit"
                                onClick={submitForm}>
                                שליחה
                            </button>
                        </div>

                        {isChecked && <div className="redMailSharing">
                            <p className="sharingTitle">אפשר גם דרך</p>
                            <div className="sharingButtons">
                                <a href="https://t.me/ynetTbot" className="telegramButton" target="_blank">
                                    <img alt="טלגרם" />
                                    <div>טלגרם</div>
                                </a>
                                <a href="https://wa.me/972548243550" className="whatsappButton" target="_blank">
                                    <img alt="וואטסאפ" />
                                    <div>וואטסאפ</div>
                                </a>
                            </div>
                        </div> 
                        }

                    </div>
                    }
                 </div>
                </div>
            </div>

        )
    }
}



